<app-user-card-request-detail-form
    [data]="data"
></app-user-card-request-detail-form>